import { Injectable } from '@angular/core';
import { from, Observable, of, scheduled, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { GraphQLService } from './graph-ql.service';
@Injectable({
  providedIn: 'root',
})
export class MenuService extends GraphQLService {
  constructor() {
    super();
  }

  getMenuByHandle(handle: string, language?: string) {
    // TODO first add menu to new version of schema ed.
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('menu', { args: { handle } }, (menus: any) => {
        menus.add('id');
        menus.add('handle');
        menus.add('title');
        menus.add('itemsCount');
        menus.add('items', (menu: any) => {
          menu.add('id');
          menu.add('title');
          menu.add('url');
          menu.add('type');
        });
      });
    });
    return from(this.client.send(query)).pipe(
      map((a: any) => {
        return a['data'].menu;
      })
    ) as Observable<any>;
    // return from(this.client.send(query)).pipe(map(({ data, model }) => data.menu));
  }

  //? tijdelijk omdat menus nog niet bestaan
  // getMenuByHandle(handle: string) {
  //   const query = this.client.query(root => {
  //     // root.add('collectionByHandle', { args: { handle } }, products => {
  //     root.addConnection('products', { args: { first: 1 } }, products => {
  //       products.add('id');
  //       products.add('title');
  //       products.add('handle');
  //     });
  //   });

  //   return from(this.client.send(query)).pipe(map(({ data, model }) => data.products.edges[0].node)) as Observable<any>;
  // }
}
